// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.full-width {
    margin-left: 60px;
    width:70%;
}
.actions{
    display: flex;
    justify-content: center;
}
.center-content {
    margin: auto !important;
    text-align: center;
}`, "",{"version":3,"sources":["webpack://./src/app/modules/administrator/doa-sub-categories/add-update-dialog/add-update-dialog/add-update-dialog.component.css"],"names":[],"mappings":"AAAA;IACI,iBAAiB;IACjB,SAAS;AACb;AACA;IACI,aAAa;IACb,uBAAuB;AAC3B;AACA;IACI,uBAAuB;IACvB,kBAAkB;AACtB","sourcesContent":[".full-width {\n    margin-left: 60px;\n    width:70%;\n}\n.actions{\n    display: flex;\n    justify-content: center;\n}\n.center-content {\n    margin: auto !important;\n    text-align: center;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
